export const API_URL = 'https://neo-manager.ru/api';
export const API_ARSHIN = 'https://fgis.gost.ru/fundmetrology/eapi';
